module.exports = __webpack_public_path__ + "media/images/creator/home/about-01@3x-f3843c9ffe4560654b5d1da5eec8c076.png";